<ul class="quick-nav">
  <li routerLink="/procedural-instructions/dashboard" class="nav-link active">
    {{ "quickNav.proceduralInstructions" | translate }}
  </li>
  <li class="nav-link disabled">
    {{ "quickNav.learningContent" | translate }}
  </li>
</ul>
